<div class="flex flex-column w-full h-screen min-h-screen">
  <!-- Content -->
  <div class="flex flex-1 justify-content-center align-items-center">
      <!-- Card -->
      <medsurf-design-content-card 
        class="w-24rem min-w-small-content relative"
        titleText="global.login">
        @if(authControlFacade.user$ | async; as user) {
          @if (authControlFacade.canAccessAuthor$ | async) {
            <button medsurf-design-input-button
              id="start_page"
              [label]="'global.go_to_author' | translate"
              (click)="goToAuthor()"
            ></button>
          } @else {
            <div class="mb-2">
              {{ 'global.logged_in_as' | translate }} {{ user.email }}<br><br>
              {{ 'notification.no_access_rights_for_author' | translate }}<br><br>
            </div>
            <div class="flex gap-2">
              <button medsurf-design-input-button
                id="start_page"
                [label]="'global.start_page' | translate"
                (click)="goToViewer()"
              ></button>
              <button medsurf-design-input-button
                id="logout"
                [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.DANGER"
                [label]="'global.logout' | translate"
                (click)="logout()"
              ></button>
            </div>
          }
        } @else {
          <button medsurf-design-input-button
            id="login"
            class="w-full"
            (click)="login()"
          >
          <span class="flex w-full justify-content-center align-items-center gap-2">
            <img src="assets/images/iml_logo.png" width="24" alt="Login">
            <span>IML Auth</span>
          </span>
        </button>
        <br>
        }
      </medsurf-design-content-card>
    </div>
  </div>
